import React from 'react';
import { utcToZonedTime } from 'date-fns-tz';

import { formatDate } from '@utils/kpi-utils/date';
import { getTaskStatusIcon } from '@components/common/Gantt/utils';

import { Task } from '@interfaces/ganttTasks/ganttTasks';

import { formatTemplateDefault, timezoneUTC } from '@constants/common';
import { getCellColor } from '@components/ModalComponents/TaskForm/Details/PrioritySelectOption/constants';

import styles from './StandardTooltipContent.module.scss';

type StandardTooltipContentProps = {
	task: Task;
}

const StandardTooltipContent: React.FC<StandardTooltipContentProps> = ({
	task,
}) => {
	const {
		start,
		end,
		isWithoutStartDate,
		isWithoutEndDate,
		priority,
		status,
		assignees,
	} = task;

	const cellColor = priority?.name && getCellColor(priority.name);
	const priorityTitle = priority?.title;
	const statusIcon = status?.name && getTaskStatusIcon(status.name);
	const statusTitle = status?.title;
	const assigneesString = assignees?.map(({ fullName }: { fullName: string }) => fullName).join(', ');

	return (
		<div className={styles.tooltipDefaultContainer}>
			<>
				{task.name}
			</>
			{cellColor && priorityTitle
				&& <div className={styles.rowContainer}>
					<div
						className={styles.colorCell}
						style={{ background: cellColor }}
					/>
					<>
						{priorityTitle}
					</>
				</div>
			}
			{statusTitle
				&& <div className={styles.rowContainer}>
					{statusIcon
						? <>
							<div className={styles.statusIcon}>
								{statusIcon}
							</div>
							<>
								{statusTitle}
							</>
						</>
						: <>
							{`Status: ${statusTitle}`}
						</>
					}
				</div>
			}
			{!isWithoutStartDate
				&& <div className={styles.rowContainer}>
					{`Start date: ${formatDate(utcToZonedTime(start, timezoneUTC), formatTemplateDefault)}`}
				</div>
			}
			{!isWithoutEndDate
				&& <div className={styles.rowContainer}>
					{`End date: ${formatDate(utcToZonedTime(end, timezoneUTC), formatTemplateDefault)}`}
				</div>
			}
			{assignees && assigneesString
				&& <div className={styles.rowContainer}>
					{`Assignees: ${assigneesString}`}
				</div>
			}
		</div>
	);
};

export default StandardTooltipContent;
